import React from 'react';
import { useDropzone } from 'react-dropzone';
import { mimeTypes } from '../assetUtils';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import _ from 'shared/lib/gettext';

type Props = {
  children: React.ReactNode,
  inline: boolean,
  allowUpload: boolean,
  onDropHandler: (acceptedFiles: File[], rejectedFiles: File[]) => void,
  NavBar: ({ openUploadModal }: { openUploadModal: () => void }) => React.ReactElement
}

export default function Dropzone(props: Props) {
  const {
    children,
    inline,
    allowUpload,
    onDropHandler,
    NavBar
  } = props;

  const {
    getRootProps,
    getInputProps,
    open,
    isDragActive
  } = useDropzone({
    accept: [].concat(mimeTypes.documents, mimeTypes.images, mimeTypes.videos),
    onDrop: onDropHandler,
    noClick: true,
    noKeyboard: true,
    disabled: !allowUpload
  });

  return (
    <Container
      {...getRootProps({
        className: 'dropzone',
        style: {
          paddingTop: inline ? '49px' : '0px'
        }
      })}
    >
      <input {...getInputProps()} />
      <NavBar
        openUploadModal={open}
      />
      { children }
      {
        allowUpload && isDragActive &&
        <DropTarget>{_('DRAG_FILES_HERE')}</DropTarget>
      }
    </Container>
  );
}

const Container = styled(Box)({
  minHeight: '300px',
  margin: '16px',
  fontFamily: FONT_FAMILY_ROBOTO,
  width: 'fill-available',
});

const DropTarget = styled(Box)({
  position: 'absolute',
  opacity: '.3',
  left: '0',
  right: '0',
  top: '0',
  bottom: '0',
  width: '100%',
  height: '100%',
  display: 'flex',
  color: 'white',
  fontSize: '18px',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#141618'
});
